import { render, staticRenderFns } from "./GroupJoinedList.vue?vue&type=template&id=623659d0&scoped=true"
import script from "./GroupJoinedList.vue?vue&type=script&lang=js"
export * from "./GroupJoinedList.vue?vue&type=script&lang=js"
import style0 from "./GroupJoinedList.vue?vue&type=style&index=0&id=623659d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623659d0",
  null
  
)

export default component.exports